import React, { useEffect, useState } from "react";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "./TabPanel/TabPanel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import classes from "./specialevents.module.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookie from "js-cookie";
import TimeOffPTOLinkComp, { ComponentType } from "./TimeOffPTOLinkComp2";
import TimeOffPTOLinkComp2 from "./TimeOffPTOLinkComp2";
import { InfoIcon } from "../../Resources/availabilityicon/IconUtils";
const SpecialEvents = () => {
  const [value, setValue] = React.useState(0);
  const personDetails = useSelector((state) => state.person.personData);
  const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);
  const urlDetails = useSelector((state) => state.url.urlData);
  const handleChange = (_event, newValue) => setValue(newValue);
  const location = useLocation();
  console.log("event",location.state)
  const navigate = useNavigate();
  const ptoQuickRefLink =urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_QRC; //REACT_APP_WFM_AVAILABILITY_SEA_TIMEOFF
  const ptoLink = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_PTO_URL;
  const [sEvents, setSEvents] = useState([]);
  const colleagueTKN = Cookie.get('X_TKN'); 

  useEffect(() => {
    getEventsByDivId();
  }, []);

  //Remove this api call and recieve data from home.js to render all events through propss
  const getEventsByDivId = () => {
    const eventData = {
      // divNbr: personDetails.mydiv,
      // locNbr: personDetails.mystore,
      // dpt: personDetails.mydept,
      divNbr: personODSFuture.mydiv,
      locNbr: personODSFuture.mystore,
      dpt: personODSFuture.mydept,
      myWorkSchedule: personODSFuture.myworkschedule,
      myDateDisplayed : "",
      ascNbr: personDetails.emplID,
      } 

      // get all events api
      axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLEVENTS}`, eventData, {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + colleagueTKN
        }
      }).then((response) => {
        console.log("-----event before", response.data)
        let data = response.data;
        setSEvents(getFilteredEvent(data));
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLEVENTS}...failed`})
        }
      });
  }; 

  const getFilteredEvent = (eventList) => {
    if(eventList != null)
     return eventList.filter((event) => event.result == 'True');
     return [];

  }
 // console.log("PTO URL:",ptoLink);
  return (
    <diV className="main_body">
      <div className={classes.titledescription}>
        <div className={classes.titlepage}>
          <div className={classes.h1} >Special Events</div>
        </div>
        <div className={classes.adjustLinks} >
        <TimeOffPTOLinkComp2  type={ComponentType.SEA}/>
        </div>
        
        </div>
      
      <div>
        <TabPanel value={value} index={0}>
          <h3 className={classes.h3}>Select the event and let us know your availability</h3>
          <div className={classes.tiles}>
            {sEvents && sEvents.map((e) => (
              //event "detail" as route
              <Link className={classes.link} to="details" state={{ eId: e.eventId, eName: e.eventName}}>
                <div id={e.eventId} className={`${classes.tile} ${classes.preferred}`}>
                  
                    <div className={classes.setitle}>
                      <div>
                        <b>{e.eventName}</b>
                      </div>
                      <div style={{marginTop:'5px'}}>{e.eventDates}</div>
                      {
                        e.eventNbrDays > 1 ? <div style={{marginTop:'5px'}}>{e.eventNbrDays} Days </div> :
                        <div style={{marginTop:'5px'}}>{e.eventNbrDays} Day </div>
                      }
                     
                    </div>
                  
                  <div className={classes.btnPrimary}>
                    
                    <div style={{marginTop: '5px'}}> 
                    {e.responseSet === "Y" && e.unavailable === "N" &&
                    <>
                      <InfoIcon /> Selections Made. Edit Until {new Date(e.eventLasteditdate).toLocaleString('default', { month: 'short' }) + " " + new Date(e.eventLasteditdate).getDate()}
                    </>
                   } 
                   {e.responseSet === "N" && e.unavailable === "N" &&
                    <>
                      <InfoIcon /> Make Your Selection(s) By {new Date(e.eventLasteditdate).toLocaleString('default', { month: 'short' }) + " " + new Date(e.eventLasteditdate).getDate()}
                    </>
                   }
                   {e.unavailable === "Y" &&
                    <>
                      <InfoIcon /> Unavailable for this event. Edit until {new Date(e.eventLasteditdate).toLocaleString('default', { month: 'short' }) + " " + new Date(e.eventLasteditdate).getDate()}
                    </>
                   }
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          Item Two
        </TabPanel>
      </div>
    </diV>
  );
};

export default SpecialEvents;
